export function call(requestType, url, data = null) {
  return new Promise((resolve, reject) => {
    axios[requestType](url, data)
      .then((response) => {
        resolve(response)
      })
      .catch(({ response }) => {
        // Clear the window store of any user session...
        if (response.status === 401) {
          auth.clearUserSession()
          // @todo call auth.signOut() ?
          // and/or reload or router.push({ path: '/' })
          window.location.reload()
        }
        reject(response)
      })
  })
}

export function get(url, data = null) {
  return call('get', url, data)
}

export function post(url, data = null) {
  return call('post', url, data)
}

export function put(url, data = null) {
  return call('put', url, data)
}

export function remove(url, data = null) {
  return call('delete', url, data)
}

export default {
  get,
  post,
  put,
}
